export default function declension(number, titles) {
  const cases = [2, 0, 1, 1, 1, 2]
  return titles[
    number % 100 > 4 && number % 100 < 20
      ? 2
      : cases[number % 10 < 5 ? (Number.isInteger(number % 10) ? number % 10 : 4) : 5]
  ]
}
